import React from "react";
import * as Icons from "lucide-react";
import { Reveal, Overline } from "../components/site/Reveal";
import { EDUCATION, TECH_TOOLS } from "../data/content";

export const Qualifications = () => (
  <section id="qualifications" className="relative bg-white py-24 sm:py-32" data-testid="qualifications-section">
    <div className="mx-auto max-w-[1400px] px-5 sm:px-8">
      <div className="max-w-2xl">
        <Reveal><Overline>Qualifications & Certifications</Overline></Reveal>
        <Reveal delay={0.05}>
          <h2 className="mt-6 font-serif text-4xl font-light leading-tight text-charcoal sm:text-5xl">
            Deep academic foundations, <span className="text-gradient-gold">real-world tools</span>.
          </h2>
        </Reveal>
      </div>

      {/* Education */}
      <div className="mt-14 grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
        {EDUCATION.map((e, i) => {
          const Icon = Icons[e.icon] || Icons.Award;
          return (
            <Reveal key={e.degree} delay={i * 0.08}>
              <div data-testid={`education-${i}`}
                className="group h-full rounded-2xl border border-black/5 bg-bg-light p-6 transition-[transform,border-color] duration-500 hover:-translate-y-1 hover:border-gold/40">
                <div className="flex h-12 w-12 items-center justify-center rounded-xl bg-emerald-base text-gold-light transition-colors duration-500 group-hover:bg-gold group-hover:text-emerald-darkest">
                  <Icon size={22} />
                </div>
                <h3 className="mt-5 font-serif text-2xl text-charcoal">{e.degree}</h3>
                <p className="mt-1 text-sm text-charcoal/60">{e.note}</p>
              </div>
            </Reveal>
          );
        })}
      </div>

      {/* Technical Systems & Tools */}
      <Reveal delay={0.1}>
        <div className="mt-16 flex items-center gap-3">
          <Icons.Cpu size={18} className="text-emerald-base" />
          <h3 className="text-xs font-bold uppercase tracking-[0.25em] text-emerald-base">Technical Systems & Tools</h3>
        </div>
      </Reveal>
      <div className="mt-8 grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
        {TECH_TOOLS.map((t, i) => (
          <Reveal key={t.name} delay={(i % 3) * 0.06}>
            <div data-testid={`tool-${i}`}
              className="group flex h-full items-start gap-3 rounded-xl border border-black/5 bg-bg-light p-4 transition-colors duration-300 hover:border-gold/40">
              <Icons.CheckCircle2 size={17} className="mt-0.5 shrink-0 text-emerald-light" />
              <div>
                <p className="text-sm font-semibold text-charcoal">{t.name}</p>
                <p className="mt-0.5 text-xs leading-relaxed text-charcoal/55">{t.note}</p>
              </div>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
